export const IMAGES_EXT = ["png", "jpg", "jpeg"];
export const DOCS_EXT = ["xlsx", "xls", "docx", "doc"];
export const VIDEOS_EXT = ["mp4", "mov", "ogv"];
export const EMBED_BROWSER_EXT = ["pdf", "txt"];